import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import DeploymentRequests from 'app/requests/Deployment.requests'
import {
    Deployment,
} from '../Deployment.types'

const useGetDeployment = (id) => {
    return useRequest<Deployment>({
        key: RequestKeys.getDeployment,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(DeploymentRequests.get),
        enabled: Boolean(id),
    })
}

export default useGetDeployment
